<div id="create-company-popup" class="common-company-popup popup-sm">
    <form class="form" role="form" autocomplete="off" [formGroup]="addSubCompanyForm" >
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Crear empresa</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">
                <div class="form-wrap">
                    <mat-label class="label">Nombre</mat-label>
                    <mat-form-field appearance="fill">
                        <input formControlName="companyName"  matInput placeholder="" value="">
                    </mat-form-field>
                    <mat-error
                    *ngIf="addSubCompanyForm.get('companyName').invalid && addSubCompanyForm.get('companyName').touched">
                    <span *ngIf="addSubCompanyForm.get('companyName').hasError('required')">La empresa es obligatoria</span>
                    </mat-error>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="addSubCompany()"><span class="mat-button-wrapper">{{saveButtontext}}</span></button>
            <button class="cancel" (click)="cancel(0)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>